import de from '../../ef-coupon-top/comps/langs/de';
import es from '../../ef-coupon-top/comps/langs/es';
import fr from '../../ef-coupon-top/comps/langs/fr';
import it from '../../ef-coupon-top/comps/langs/it';
import jp from '../../ef-coupon-top/comps/langs/jp';
import kr from '../../ef-coupon-top/comps/langs/kr';
import us from '../../ef-coupon-top/comps/langs/us';

import au from '../../ef-coupon-top/comps/langs/au';
import ca from '../../ef-coupon-top/comps/langs/ca';
import eu from '../../ef-coupon-top/comps/langs/eu';
import uk from '../../ef-coupon-top/comps/langs/uk';
import za from '../../ef-coupon-top/comps/langs/za';
import br from '../../ef-coupon-top/comps/langs/br';
import mx from '../../ef-coupon-top/comps/langs/mx';
import ph from '../../ef-coupon-top/comps/langs/ph';
import nl from '../../ef-coupon-top/comps/langs/nl';

export const langTextRules: any = {
    us: us,
    de: de,
    fr: fr,
    it: it,
    es: es,
    jp: jp,
    kr: kr,
    nl: nl,

    au: au,
    ca: ca,
    eu: eu,
    uk: uk,
    za: za,
    br: br,
    mx: mx,
    ph: ph,
};
